<template>
    <v-form ref="simSettForm">
      <v-row align="center" justify="center">
        <h3><b>{{$t('json.simsettings')}}</b></h3>
      </v-row>
      <v-row align="center" justify="center">
        <v-col :cols="7">
          <v-text-field autocomplete="off"  @change="onChange" :label="$t('json.simendpoint')" v-model="SimSettings.Endpoint" :rules="[() => !!SimSettings.Endpoint || $t('json.ruleempty')]" required validate-on-blur ></v-text-field>
          <v-switch v-model="SimSettings.Exchange" @change="onChange" :label="$t('json.simenableexchange')"></v-switch>
          <v-text-field autocomplete="off"  @change="onChangeSUser" :label="$t('json.simuser')" v-model="simUser" required validate-on-blur ></v-text-field>
          <v-text-field @change="onChangeSPass" :label="$t('json.simpass')" @click:append="SimSettings.showPass = !SimSettings.showPass" :append-icon="useAppendIconSim" :type="SimSettings.showPass ? 'text' : 'password'" v-model="simPass" required validate-on-blur ></v-text-field>
          <!-- <v-text-field autocomplete="off"  @change="onChangeSUser" :label="$t('json.simuser')" v-model="simUser" :rules="[(v) => !!v || $t('json.ruleempty')]" required validate-on-blur ></v-text-field>
          <v-text-field @change="onChangeSPass" :label="$t('json.simpass')" @click:append="SimSettings.showPass = !SimSettings.showPass" :append-icon="useAppendIconSim" :type="SimSettings.showPass ? 'text' : 'password'" v-model="simPass" :rules="[(v) => !!v || $t('json.ruleempty')]" required validate-on-blur ></v-text-field> -->
          <!-- <v-btn :disabled="(simUser + simPass).length === 0" @click="saveSimUP" block color="primary">{{ $t('json.saveup') }}</v-btn> -->
          <v-switch :disabled="disable" @change="onChange" :label="$t('json.export_skip')" v-model="SimSettings.SkipExportSettings"></v-switch>
          <v-btn :disabled="SimSettings.Endpoint.trim().length === 0" @click="saveSimUP" block color="primary">{{ $t('json.saveup') }}</v-btn>
          <br/>
        </v-col>
      </v-row>
    </v-form>
</template>

<script>
export default {
  name: 'SimEndpointSettings',
  props: {
    SimSettings: {
      type: Object
    },
    disable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      simUser: '',
      simPass: '',
      initedSimPass: false
    }
  },
  computed: {
    useAppendIconSim () {
      if (this.initedSimPass) return undefined
      return this.SimSettings.showPass ? 'mdi-eye' : 'mdi-eye-off'
    }
  },
  mounted () {
    // console.log('onMounted SimEndpointSettings', this.SimSettings)
    if (this.SimSettings.PasswordCrypt !== '') {
      const crypto = atob(this.SimSettings.PasswordCrypt)
      this.simUser = crypto.substring(0, crypto.indexOf(':'))
      this.simPass = crypto.substring(crypto.indexOf(':') + 1)
      if (this.simPass) this.initedSimPass = true
      console.log(this.simUser, this.simPass)
    }
  },
  methods: {
    async onChangeSUser (val) {

    },
    async onChangeSPass (val) {
      if (!this.simPass) {
        this.initedSimPass = false
      }
    },
    async saveSimUP () {
      // if (!this.simUser || this.simUser.trim().length === 0) { return }
      // if (!this.simPass || this.simPass.trim().length === 0) { return }
      // this.SimSettings.UserName = this.simUser
      // this.SimSettings.Password = this.simPass
      if (this.simUser.trim().length === 0 && this.simPass.trim().length === 0) {
        this.SimSettings.PasswordCrypt = btoa('')
      } else {
        this.SimSettings.PasswordCrypt = btoa(this.simUser + ':' + this.simPass)
      }
      this.$emit('changeSettings')
    },
    async onChange (val) {
      if (this.SimSettings.Endpoint.indexOf('/api/request') > 0) {
        this.SimSettings.IsSimLite = true
      } else {
        this.SimSettings.IsSimLite = false
      }
      console.log(this.SimSettings)
      this.$emit('changeSettings')
    }
  }
}
</script>
